import React, { FC, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { useUrlQuery } from 'src/utils/useURLQuery';
import { tokens, Loading } from '@beeline.com/bp-design-system';
import { PAGE_ROUTES as Routes } from '../pageRoutes';
import { ExternalComplete } from './ExternalComplete';
import 'iframe-resizer/js/iframeResizer.contentWindow';
import { useExternalIntl } from './translations/useExternalIntl';

export const ExternalRoutes: FC<React.PropsWithChildren<{}>> = () => {
  const history = useHistory();
  const urlQuery = useUrlQuery();
  const basePath = '/external';
  const smartformPath = `${basePath}/smartforms`;
  const completePath = `${basePath}/complete`;
  const addWorkerPath = `${smartformPath}/add-worker`;
  const addJobApplicationPath = `${smartformPath}/job-application`;
  const offboardWorkerPath = `${smartformPath}/worker-offboarding`;
  const addEngagementPath = `${smartformPath}/add-engagement`;
  const updateEngagementPath = `${smartformPath}/update-engagement`;
  const taskPath = `${basePath}/tasks/:taskId`;
  const docYardPath = `${basePath}/docyard`;

  const intl = useExternalIntl();

  const routes = (
    <Suspense fallback={<Loading className="main_loader" />}>
      <Switch>
        <Route
          path={[
            addWorkerPath,
            addJobApplicationPath,
            offboardWorkerPath,
            addEngagementPath,
            updateEngagementPath,
            intl.reviewTask,
            taskPath,
            docYardPath
          ]}
          render={() => (
            <Routes.Frontdoor
              external
              onComplete={() => {
                history.push(completePath);
                // Parent is used for an iframe
                window.parent?.postMessage(`formSubmitted_${urlQuery.get('code')}`, '*');
                // Opener is used for a tab
                window.opener?.postMessage(`formSubmitted_${urlQuery.get('code')}`, '*');
              }}
            />
          )}
        />
        <Route path={completePath} component={ExternalComplete} />
        <Route render={() => <span>{intl.routeNotFound}</span>} />
      </Switch>
    </Suspense>
  );

  const externalStyles: React.CSSProperties = {
    overflowX: 'hidden',
    overflowY: 'auto',
    minHeight: 550,
    height: '100%',
    backgroundColor: tokens.colorSurface,
    color: tokens.colorOnSurface
  };

  return (
    <div className="app-wrapper" style={externalStyles}>
      {routes}
    </div>
  );
};
